<template>
    <div >
        <div class="container-fluid vh-100  " style="background:url(./assets/img/wp-login.jpg); background-size:cover">
            <div class="row h-100 ">
                <div class="col-auto  p-5 align-self-center ">
                    <div class="card card-user" style="background-color: rgba(147, 128, 128, 0.5);">
                    <div class="card-header">
                         <h5 class="card-title">KARPİEM BYS</h5>
                    </div>
                    <div class="card-body">
                    <form @submit.prevent="onSubmit">
                   <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <label class="text-dark">KULLANICI ADI</label>
                        <input v-model="user.email"  type="text" class="form-control" placeholder="" style="opacity:0.5">
                      </div>
                    </div>      
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <label class="text-dark">KULLANICI ŞİFRE</label>
                        <input v-model="user.password" type="password" class="form-control" placeholder="" style="opacity:0.5">
                      </div>
                    </div>      
                  </div>
                  <div class="row">
                    <div class="col ">
                      <div class="form-group ">
                        <button @click="login" class="btn btn-danger btn-round ">GİRİŞ YAP</button>
                      </div>
                    </div>      
                  </div>
                </form>
              </div>
              
            </div>
                </div>
                
            </div>
        </div>

      <div class="loading" :style="isLoading">
        <div class="lds-ripple">
            <div> </div>
            <div> </div>
          </div>  
      </div>



    </div>
</template>

<script>
export default {
   data(){
     return{
       user : {
         email : null,
         password : null,
       },
       loginClicked : false
     }
   },

   computed : {
     isLoading(){
       if(this.loginClicked){
         return{
           display : "block"
         }
       }else{
         return{
           display : "none"
       }

     }
   },
   },

    methods : {
      login(){
        this.loginClicked = true
        this.$store.dispatch("login", {...this.user})
        .then(response =>{
         this.$router.push("/home")
         console.log("response donduuuu")       
         
        })
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue